export var PLATFORMS;
(function (PLATFORMS) {
    PLATFORMS["NATIVE"] = "mobileNative";
    PLATFORMS["HYBRID"] = "mobileHybrid";
    PLATFORMS["WEB"] = "web";
})(PLATFORMS || (PLATFORMS = {}));
export var MODE;
(function (MODE) {
    MODE["RENDERER"] = "renderer";
    MODE["EDITOR"] = "editor";
})(MODE || (MODE = {}));
export var FULL_WIDTH_MODE;
(function (FULL_WIDTH_MODE) {
    FULL_WIDTH_MODE["FIXED_WIDTH"] = "fixedWidth";
    FULL_WIDTH_MODE["FULL_WIDTH"] = "fullWidth";
})(FULL_WIDTH_MODE || (FULL_WIDTH_MODE = {}));
//# sourceMappingURL=general-events.js.map